"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOpportunityLostDto = exports.CreateOpportunityLostDto = exports.OpportunityLost = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class OpportunityLost {
}
exports.OpportunityLost = OpportunityLost;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 404,
        description: "Reason for loss ID",
    }),
    (0, class_validator_1.IsInt)({ message: "Reason for loss ID must be an integer" }),
    (0, class_validator_1.Min)(1, { message: "Reason for loss ID must be a positive integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Reason for loss is required" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityLost.prototype, "reasonForLossLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "This opportunity was lost due to budget constraints",
        description: "A brief description of the reason for loss",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityLost.prototype, "remarks", void 0);
class CreateOpportunityLostDto {
}
exports.CreateOpportunityLostDto = CreateOpportunityLostDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 76,
        description: "The ID of the opportunity activity.",
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity activity ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity activity ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityLostDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: OpportunityLost,
        description: "The details of the opportunity lost",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity lost details are required" }),
    (0, class_transformer_1.Type)(() => OpportunityLost),
    tslib_1.__metadata("design:type", OpportunityLost)
], CreateOpportunityLostDto.prototype, "opportunityLost", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 404,
        description: "The statusLid of the LookUp",
    }),
    (0, class_validator_1.IsInt)({ message: "statusLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "statusLid is required" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityLostDto.prototype, "statusLid", void 0);
class UpdateOpportunityLostDto extends (0, swagger_1.PartialType)(CreateOpportunityLostDto) {
}
exports.UpdateOpportunityLostDto = UpdateOpportunityLostDto;
